import Header from '@components/layout/header';
import './myEarnings.css';
import { Button, Table } from 'antd';
import { PaymentInfo } from '@type/db-types';

export default function MyEarnings() {
    return (
        <>
            <Header pageTitle={'My Earnings'} />
            <div className="main-container-inner p-4">
                <div className="balance-wrapper">
                    <h5>
                        Earnings available now: <span className="balance">$50</span>
                    </h5>
                    <div className="withdraw-wrapper">
                        <Button className="withdaw-btn btn-primary  rounded-pill" type="primary">
                            Withdraw
                        </Button>
                    </div>
                </div>

                <div className="table-wrapper mt-4 w-100">
                    <div className="d-flex align-items-center justify-content-between">
                        <h3>Transaction history</h3>
                    </div>
                    <Table
                        dataSource={data}
                        columns={columns}
                        rowKey="id"
                        scroll={{ y: 'calc(100vh - 100px)' }}
                        // loading={isLoading}
                        // pagination={{
                        //   current: defaultCurrent,
                        //   total: coachesList?.total || 0,
                        //   onChange: (page, pageSize) => {
                        //     setDefaultCurrent(page);
                        //     const offset = pageSize * (page - 1);
                        //     fetchCoaches(offset, pageSize);
                        //   },
                        //   showSizeChanger: false,
                        // }}
                    />
                </div>
            </div>
        </>
    );
}

const columns = [
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'Date',
        render: (
            _value: unknown,
            record: Pick<PaymentInfo, 'amount' | 'id' | 'createdAt' | 'type'>,
        ) => {
            return <>{record?.createdAt || '2024-09-01'}</>;
        },
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
    },

    {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
    },
];

const data: Pick<PaymentInfo, 'amount' | 'id' | 'createdAt' | 'type'>[] = [
    {
        createdAt: '2021-09-01',
        id: '1',
        type: 'team_membership',
        amount: 20,
    },
    {
        createdAt: '2021-09-01',
        id: '2',
        type: 'event',
        amount: 25,
    },
    {
        createdAt: '2021-09-01',
        id: '3',
        type: 'team_membership',
        amount: 30,
    },
    {
        createdAt: '2021-09-01',
        id: '4',
        type: 'event',
        amount: 18,
    },
    {
        createdAt: '2021-09-01',
        id: '5',
        type: 'team_membership',
        amount: 22,
    },
    {
        createdAt: '2021-09-01',
        id: '6',
        type: 'event',
        amount: 27,
    },
    {
        createdAt: '2021-09-01',
        id: '7',
        type: 'team_membership',
        amount: 19,
    },
    {
        createdAt: '2021-09-01',
        id: '8',
        type: 'event',
        amount: 32,
    },
    {
        createdAt: '2021-09-01',
        id: '9',
        type: 'team_membership',
        amount: 21,
    },
    {
        createdAt: '2021-09-01',
        id: '10',
        type: 'event',
        amount: 35,
    },
];
